import React, { type SVGProps } from 'react';
import type { VyIconType } from '../types/vy-icon-type';
import * as Icons from './icons';

export const VyIconOptions = Object.keys(Icons) as VyIconType[];

export type VyIconProps = SVGProps<SVGSVGElement> & {
  icon: VyIconType;
};
export const VyIcon: React.FC<VyIconProps> = ({ icon, ...props }) => {
  const Component = React.createElement(Icons[icon], props);

  return <span className="vy-icon">{Component}</span>;
};
